import { SeoOurusers } from "../components/Public/SeoTdk";
import Layout from "../components/Public/Layout";
import styles from "./ourusers.module.scss";

export default function Contact() {
  const listArr = [
    {
      pic: "/img/user1.png",
      say: "“I got a California phone number on Dingtone, and it makes my business look more professional.”",
      firstname: "Daniele",
      name: "——Daniele Ortelli",
      title: "A Good Phone Number App Helps a Lot for My Business.",
      desc: "Daniele runs a popular music radio in Italy. The US phone number from Dingtone helps him take business calls on his existing phone, so he can connect with global fans without barriers.",
      url: "http://blog.dingtone.me/en/202111-dingtone-user-story-1/",
    },
    {
      pic: "/img/user2.png",
      say: "“I’m shocked it’s really awesome and also saves money, so I earned free credits and make free call.”",
      firstname: "Mithun",
      name: "——Mithun Kaji",
      title: "Not Only Luck: Mithun Kaji Won 1000 Credits in Dingtone Lottery.",
      desc: "Mithun is from India and now works in Saudi Arabia. He uses Dingtone to stay in touch with family and friends back home, and no longer worries about phone bills.",
      url: "http://blog.dingtone.me/en/202111-dingtone-user-story-2/",
    },
    {
      pic: "/img/user3.png",
      say: "“Earning credits is what I like most about dingtone. This is an incredible feature. I mean you are earning credits for real! How cool is that!”",
      firstname: "Arnab",
      name: "——Arnab Talukder",
      title: "Earning Free Credits is what I enjoy most about Dingtone",
      desc: "While some users are still at the very beginning of earning credits, Arnab has found pleasure therein. He use the cheap call feature while talking to friends living in other countries.",
      url: "http://blog.dingtone.me/en/202111-dingtone-user-story-3/",
    },
    {
      pic: "/img/user4.png",
      say: "“I have only Dingtone for calling, nothing else. I have earned money through YouTube just for my video about Dingtone tips!”",
      firstname: "Shamim",
      name: "——Md Shamim Hossain",
      title: "My Videos About Dingtone Attracted 10000+ Views",
      desc: "Shamim has his own Youtube Channel blogging about tricks and tips. Several of his videos about Dingtone have attracted thousands of views.",
      url: "http://blog.dingtone.me/en/202111-dingtone-user-story-4/",
    },
  ];
  return (
    <div className="page">
      <SeoOurusers />
      <Layout>
        <div className={styles.ourusers}>
          <div className={styles.banner}></div>

          <div className={styles.inner + " main"}>
            <h1>Our Users</h1>

            <div className={styles.list}>
              {listArr.map((item, index) => (
                <div className={styles.item + " flex-r"} key={index}>
                  <div className={styles.left}>
                    <img src={item.pic} alt={item.name} />
                  </div>
                  <div className={styles.right}>
                    <h3>{item.say}</h3>
                    <h5>{item.name}</h5>

                    <h2>{item.title}</h2>
                    <p>{item.desc}</p>

                    <span>
                      <a href={item.url}>Read {item.firstname}’s Story</a>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}
